export default __webpack_public_path__ + "static/media/bell-icon.6c559177.svg";